export default __webpack_public_path__ + "static/media/arrow-dropdown.c0ba7d04.svg";